import { Attachment } from '../attachments.model';
import { GuidelineValidationResult } from '../GuidelineValidationResult';
import { BaseEditableProperties, Widget } from './widget.model';
import { Reference } from '../reference.model';

export type ChapterWidget = Widget & {
  widgetType: 'chapter';
  title?: string;
  childrenIds?: string[];
  no?: string;
  widgetIds?: string[];
  updatedWidgetIds?: string[];
} & {
  localChanges?: ChapterWidgetLocalChanges;
};

export type ChapterWidgetLocalChanges = BaseEditableProperties &
  Partial<{ updatedWidgetIds: string[]; deletedOriginalAttachmentIds: string[]; attachments: Attachment[] }>;

export const createChapterWidget = (widget: Omit<ChapterWidget, 'getReferences' | 'validate' | 'widgetType'>): ChapterWidget => ({
  uniqueId: crypto.randomUUID(),
  references: [],
  links: [],
  attachments: [],
  ...widget,
  widgetType: 'chapter',
});

export const getReferencesFromChapterWidget = (widget: ChapterWidget): Reference[] => {
  return widget.references || [];
};

export const validateChapterWidget = (widget: ChapterWidget): GuidelineValidationResult => {
  if (!widget.title) {
    return {
      valid: false,
      message: 'OneChapterHasTitleMissing',
    };
  }

  return {
    valid: true,
    message: '',
  };
};
